export default {
    mainContainer: { 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        columnGap: '20px', 
        rowGap: '20px', 
        margin: '10%'
    },
    displayNone: {
        display: 'none'
    },
    pointerCursor: {
        cursor: 'pointer'
    },
}